// 1. Parameter aus URL holen
const params = new URLSearchParams(window.location.search);
const id = params.get('id');
const qty = parseInt(params.get('qty')) || 1;

if (id) {
  const cartNotification = document.querySelector('cart-notification');
  const sections = cartNotification ? cartNotification.getSectionsToRender().map((section) => section.id) : [];

  const formData = {
    'id': id,
    'quantity': qty,
    'sections': sections.join(','),
    'sections_url': window.location.pathname
  };

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(formData)
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.status === 422) {
      alert(response.description);
    }
    cleanUpUrl();
    window.location.href = '/cart';
  })
  .catch((error) => {
    console.error('Fehler beim Hinzufügen:', error);
  });
}

function cleanUpUrl() {
  const url = new URL(window.location);
  url.searchParams.delete('id');
  url.searchParams.delete('qty');
  
  window.history.replaceState({}, document.title, url.pathname + url.search);
}